import { useMemo } from 'react';

/**
 * @typedef {Object} ResourceCardAction
 * @property {string} id JSON attribute name
 * @property {string} name Meta name identifier. This can be used to identify an action as well.
 * @property {string} label Meta display text
 * @property {string} [imageURL] Meta image/icon URL
 * @property {Link} link Relationship link
 * @property {string} unavailableReason unavailable text copy
 * @property {Relationship} relationship Relationship
 */

const RELATIONSHIP_NAME_ON_CLICK = 'main';

/**
 * @param resource {Resource}
 */
export default function useResourceSummary(resource) {
  /** @type {ResourceCardAction[]} */
  const actions = useMemo(() => resource
  // convert relationships to a list
    .relationships().list()
  // only action relationships except main
    .filter(relationship => (relationship.meta('type') === 'action') && (relationship.attr('name') !== RELATIONSHIP_NAME_ON_CLICK))
  // convert to ResourceCardAction list
    .map(relationship => ({
      id: relationship.attr('name'),
      name: relationship.meta('name'),
      label: relationship.meta('label'),
      image: relationship.meta('image'),
      link: relationship.link('related'),
      relationship,
    })),
  [resource.relationships()]);

  /** @type {ResourceCardAction} */
  const mainAction = useMemo(
    () => {
      if (resource.relationship(RELATIONSHIP_NAME_ON_CLICK)) {
        const relationship = resource.relationship(RELATIONSHIP_NAME_ON_CLICK);
        return {
          id: relationship.attr('name'),
          name: relationship.meta('name'),
          icon: relationship.meta('icon'),
          label: relationship.meta('label'),
          link: relationship.link('related'),
          unavailableReason: resource.attr('unavailableReason'),
          relationship,
        };
      }
      return null;
    },
    [resource.relationships()],
  );

  return {
    title: resource.attr('title'),
    subtitle: resource.attr('subtitle'),
    image: resource.attr('image'),
    status: resource.attr('status'),
    statusText: resource.attr('statusText'),
    actions,
    mainAction,
  };
}
